import { BimPriceLevelEnum } from 'gql/graphql';
import type { Badge } from 'uikit';

import type { ComponentPropsWithoutRef, CSSProperties, Dispatch, SetStateAction } from 'react';

export type IBimLevelChoiceProps = {
    priceLevel: BimPriceLevelEnum | undefined;
    setPriceLevel: Dispatch<SetStateAction<BimPriceLevelEnum | undefined>>;
    isDisabledWithoutValue?: boolean;
    style?: CSSProperties;
};

export type IBimLevelBadgeProps = {
    priceLevel: BimPriceLevelEnum | undefined;
} & ComponentPropsWithoutRef<typeof Badge>;

export const priceLevels = [
    { id: BimPriceLevelEnum.BasicPriceLevel, name: 'Базисный' },
    { id: BimPriceLevelEnum.CurrentPriceLevel, name: 'Текущий' },
];

export const getItemPriceLevelLabel = (item: (typeof priceLevels)[0]) => item.name;

export const getItemPriceLevelLabelFromId = (id: BimPriceLevelEnum | undefined) =>
    priceLevels.find((c) => c.id === id)?.name ?? '';
